import { PilotId } from '~/eds/src/types/PilotId';
import { UfFieldValue } from '~/features/unified-fields/questionInputRegistry';
import { pilot } from '~/services/serviceInstances';

import { BaseRequest } from './types';

type Field = {
  id: PilotId;
  keepOldValues: boolean;
  value: string | string[] | number | null;
  ufFieldId?: string;
  ufFieldValue?: { data: UfFieldValue[] };
};
interface Request extends BaseRequest {
  fields?: Field[];
}

type Params = {
  document_handler_ids: PilotId[];
  query?: object;
  fields?: {
    id: PilotId;
    value: string | string[] | number | null;
    keep_old_values: boolean;
    uf_field_id?: string;
    uf_field_value?: { data: UfFieldValue[] };
  }[];
};
export const documentBulkAddReplaceFields = (
  request: Request,
): Promise<{ detail: string }> =>
  pilot.put('document/bulk-edit/', mapRequestToParams(request));

const mapRequestToParams = ({
  documentHandlerIds,
  fields,
  searchQuery,
  isAllSelected,
  searchAPI,
}: Request): Params => {
  let searchSpread: { query?: object; query_v3?: object } | undefined;
  if (isAllSelected) {
    if (searchAPI === 'v3') {
      searchSpread = { query_v3: searchQuery };
    } else {
      searchSpread = { query: searchQuery };
    }
  }

  return {
    document_handler_ids:
      !isAllSelected && documentHandlerIds ? documentHandlerIds : [],
    fields: fields?.map(
      ({ id, keepOldValues, value, ufFieldId, ufFieldValue }) => ({
        id,
        value,
        keep_old_values: keepOldValues,
        ...(ufFieldId
          ? { uf_field_id: ufFieldId, uf_field_value: ufFieldValue }
          : undefined),
      }),
    ),
    ...searchSpread,
  };
};
